<template>
	<section :class="['attachments-global-progress-ui', displayState ? 'visible' : 'hidden']">
		<div :class="['progress-ui__container', {open:openState}]">
			<div class="open-btn">
				<v-btn
					dark flat icon
					@click="toggleExpandUploader">
					<v-icon v-html="getOpenCloseIcon"/>
				</v-btn>
			</div>
			<div class="container__content--collapsed">
				<div class="info-container">
					<div>{{filesUploadProgress}} Files Complete</div>
					<div></div>
				</div>
				<div class="progress-container">
					<div class="progress-ind" :style="collapsedLoadedProgress"></div>
				</div>
			</div>
			<div class="container__content--expanded">
				<div class="content__title">
					<h2>File Uploads</h2>
				</div>
				<div class="content__files-list">
					<div class="file-list--content">
						<attachment-global-file-item
							v-for="file in getFiles"
							:key="`attachment-global-file-${getUUID}-${Math.random()}`"
							:data="file"
							/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>

	import { mapState, mapGetters, mapActions } from 'vuex'

	import { 
			VUEX_UI_SHOW_GLOBAL_UPLOADER,
		 	VUEX_UI_HIDE_GLOBAL_UPLOADER,
		 	VUEX_UI_OPEN_GLOBAL_UPLOADER,
		 	VUEX_UI_CLOSE_GLOBAL_UPLOADER } from '@/store/constants/ui'

	import AttachmentGlobalFileItem from '@/components/ui/Attachments/GlobalProgressUI/Attachments_Global_Progress_FileItem'

	export default {
		name: 'attachments-global-progress-ui',

		components: {
			'attachment-global-file-item' : AttachmentGlobalFileItem,
		},

		props: {

		},

		computed: {
			getUUID() { return this.$uuid.v4() },

			...mapState({
				openState: state => state.ui.globalUploader.openState,
				displayState: state => state.ui.globalUploader.displayState,
				job: state => state.jobs.job
			}),

			...mapGetters({
				getQueuedFiles:      'getQueuedFiles',
				getUploadingFiles:   'getUploadingFiles',
				getProcessingFiles:  'getProcessingFiles',
				getCompletedFiles:   'getCompletedFiles'
			}),

			getFiles() {
				let files = new Array()
					.concat(this.getCompletedFiles())
					.concat(this.getUploadingFiles())
					.concat(this.getProcessingFiles())
					.concat(this.getQueuedFiles())

				files.sort(function(a, b) {
					return a.addedToQueue - b.addedToQueue
				})

				return files
			},

			collapsedLoadedProgress() {
				let currNumOfFiles = this.getCompletedFiles().length
				
				let totalFiles = 
					this.getQueuedFiles().length +
					this.getUploadingFiles().length +
					this.getProcessingFiles().length +
					this.getCompletedFiles().length
				
				if(!totalFiles) return 0
					
				return { transform:'scaleX(' + (currNumOfFiles/totalFiles) + ')' }
			},

			filesUploadProgress() {
				// return '(1/6)'
				let currNumOfFiles = this.getCompletedFiles().length
				
				let totalFiles = 
					this.getQueuedFiles().length +
					this.getUploadingFiles().length +
					this.getProcessingFiles().length +
					this.getCompletedFiles().length

				return `${currNumOfFiles}/${totalFiles} `

			},

			getOpenCloseIcon() {
				return this.openState ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
			}
		},

		methods: {
			...mapActions({
				openUploader: VUEX_UI_OPEN_GLOBAL_UPLOADER,
				closeUploader: VUEX_UI_CLOSE_GLOBAL_UPLOADER
			}),

			toggleExpandUploader() {
				if (this.openState) {
					this.closeUploader()
				} else {
					this.openUploader()
				}
			}
		}
	}
</script>